import * as React from 'react';
// import { Link } from 'react-router-dom';
import { MenuRoot } from '.';

export const MenuApp = () => {
	return (
		<React.Fragment>
			{/* <MenuRoot /> */}
		</React.Fragment>
	);
};
